'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { buttonVariants } from '@/components/ui/button'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { cn } from '@/lib/utils/helpers'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'
import { FiArrowUpRight } from 'react-icons/fi'

export default function CTAChat() {
  const { session } = useAuth()
  return (
    <div className="max-w-7xl mx-auto lg:px-8 mb-24 mt-40 w-full">
      <FadeIn className="mainpartner py-16 px-6 rounded-xl">
        <FadeInStagger faster>
          <FadeIn className="flex justify-center">
            <p className="lg:w-[765px] text-center text-white text-5xl font-semibold leading-[60px]">
              Transform Ideas into Impact:
              <br /> Begin with Your Application.
            </p>
          </FadeIn>
          <FadeIn className="flex justify-center mt-4">
            <p
              className="text-[20px] font-normal leading-[30px]  lg: w-[768px] 
            text-center text-white text-xl"
            >
              AI Forge empowers visionary entrepreneurs to apply their AI
              innovations, where ambition meets guidance, and pioneering ideas
              take flight, redefining industries.
            </p>
          </FadeIn>
          <FadeIn className="flex flex-col  justify-center gap-4 mt-10 md:flex-row">
            <Link
              href="/about"
              className={cn(
                buttonVariants({ size: '2xl' }),
                'max-sm:mx-auto leading-7 text-sm sm:text-lg mt-3 sm:mt-0',
              )}
            >
              Our Program
              <FiArrowUpRight className="text-black text-2xl leading-7 ml-3" />
            </Link>
            <Link
              href={`${getApplyRedirectUrl(session)}`}
              className={cn(
                buttonVariants({ size: '2xl', variant: 'secondary' }),
                'border-[#155EEF] px-8 mt-3 sm:mt-0',
              )}
            >
              Apply Now
              <FiArrowUpRight className="text-white text-2xl leading-7 ml-3" />
            </Link>
          </FadeIn>
        </FadeInStagger>
      </FadeIn>
    </div>
  )
}
